import React from 'react'
import computer from './facilitiesphotos/computerlab.jpeg'
import pharma from './facilitiesphotos/pharmacognosylab.jpeg'
import pharma2 from './facilitiesphotos/pharmacologylab.jpeg'
import classroom from './facilitiesphotos/classroom.jpeg'
import humanlab from './facilitiesphotos/humanlab.jpeg'
import machine from './facilitiesphotos/machine.jpeg'
import garden from './facilitiesphotos/medicin.jpeg'
import { useEffect } from 'react'
import landscape from './facilitiesphotos/landscape.jpg'
import { Helmet } from "react-helmet";
const Facillities = () => {


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
   <Helmet>
        <title>Facillities Page</title>
        <meta name="description" content="Information about admission in shinde institute of pharmacy and research , Required Documents" />
      </Helmet>


      <div style={{ marginTop: "6rem" }}>
        <img src={landscape} alt="error" className="landscape" style={{ width: "100%" }}></img>
        <center>  <h1 className="centered">Home {'>'} Facillities  </h1>  </center>
      </div>



      <div className='container' style={{ marginTop: "4rem" }}>

        <center><h1 style={{ color: "rgb(44, 110, 17)" }}>  <span style={{ color: "rgb(151 201 29)" }}>Girnai </span> Shikshan Sanstha</h1>
          <h2 className='mt-3' style={{ color: "rgb(44, 110, 17)" }}><span style={{ color: "rgb(151 201 29)" }}> Welcome to Shinde </span>  Institute of Pharmacy and Research Facillities</h2></center>

        <br></br>
        <br></br>
        <div className="row mt-4">
          <div className='col-md-4 col-sm-12'  >
            <center>  <img src={computer} alt='error13' className='img-fluid'></img></center>

          </div>
          <div className='col-md-8 col-sm-12' >
            <h3 style={{ color: "rgb(44, 110, 17)" }}>COMPUTER LAB</h3>
            <p >Computer labs are fully equipped with systems and latest software with an environment to implement and experiment knowledge acquired in the classroom. All the systems have internet facility.
              The college has high-tech computer graphics studios with more than 50 advanced computers with LAN and internet services through wireless connectivity, and LCD projection systems, hardware and software, digital cameras, printers, scanners, plotters, photocopying machine and video cameras etc. All are the back bone of our infrastructure. Advance graphics lab is equipped with 120 computers with advanced configurations, a central control room, audio – visual projection facilities and a central data archiving center. As a part of BNCA’s pursuit to be technologically in sync with the times, the following hardware and systems were installed in the college:
            </p>

          </div>
        </div>

        <div className="row mt-4">

          <div className='col-md-8 col-sm-12' >
            <h3 style={{ color: "rgb(44, 110, 17)" }}>PHARMACOGNOSY LAB</h3>
            <p >Pharmacognosy lab provides adequate facilities for morphological and microscopical studies of cells and tissues in different parts like root, stem, leaf, flower, fruit and seed of natural plants, identification and standardization of crude drugs. This lab provide an opportunity for the students to gain the knowledge of physicochemical properties of the natural products and natural medications also the identification tests, extraction, isolation, detection, determination and the estimation of natural products, quantitative and qualitative analysis of drugs and phytoconstituents extracted from medicinal plants. This lab also provides an opportunity for the students to gain the knowledge of plant tissue culture techniques, crop improvement, hybridization and colonal propagation etc.

            </p>

          </div>
          <div className='col-md-4 col-sm-12'  >
            <center>  <img src={pharma} alt='error13' className='img-fluid'></img></center>

          </div>
        </div>


        <div className="row mt-4">
          <div className='col-md-4 col-sm-12'  >
            <center>  <img src={pharma2} alt='error13' className='img-fluid'></img></center>

          </div>
          <div className='col-md-8 col-sm-12' >
            <h3 style={{ color: "rgb(44, 110, 17)" }}>PHARMACOLOGY LAB</h3>
            <p >This Laboratory is utilized to determine the action of drugs on the animal or its isolated tissues. The lab is well equipped with types of specialized equipments like Convulsiometer for testing anticonvulsant effect of drugs on rats and mice, Eddy’s Hot Plate for testing analgesic effect, Plethysmograph, rota rod apparatus and cooks pole climbing apparatus for testing antipsychotic effect, Single and double unit Organ bath with recording drums are utilized for experiments on isolated tissues from the animals. The experimental animals used are albino, rats, mice, rabbit and Guinea Pigs. The animals are kept with ease in an animal house associated with the Lab. The lab is also utilized for determination of acute and chronic toxicities of the new drug molecules
            </p>

          </div>
        </div>



        <div className="row mt-5">

          <div className='col-md-8 col-sm-12' >
            <h3 style={{ color: "rgb(44, 110, 17)" }} className="mt-2">CLASSROOM</h3>
            <p >The spacious well-ventilated classrooms with natural light, provide a conducive environment for learning. Every classroom has audio-visual facilities including LIVE Streaming of classroom teaching, a public address system, display boards, lockers for students and ergonomically designed age-appropriate furniture.

            </p>

          </div>
          <div className='col-md-4 col-sm-12'  >
            <center>  <img src={classroom} alt='error13' className='img-fluid'></img></center>

          </div>
        </div>



        <div className="row mt-4">
          <div className='col-md-4 col-sm-12'  >
            <center>  <img src={humanlab} alt='error13' className='img-fluid'></img></center>

          </div>
          <div className='col-md-8 col-sm-12' >
            <h3 style={{ color: "rgb(44, 110, 17)" }} className="mt-2"> HUMAN ANATOMY AND PHYSIOLOGY LAB</h3>
            <p >The Anatomy & Physiology lab was created to introduce the structure and function of the human body. It deals with the study of cells, tissues and membranes that make up our bodies and how our major systems function to help us develop and stay healthy.The study of Anatomy includes the basic human body functions and life processes. It also describes the anatomical locations, structures and physiological functions of the main components of each major system of the human body.
            </p>

          </div>
        </div>


        <div className="row mt-5">

          <div className='col-md-8 col-sm-12' >
            <h3 style={{ color: "rgb(44, 110, 17)" }} className="mt-2">MACHINE LAB</h3>
            <p >The laboratories are well equipped with a wide range of hi-tech machines, tools, equipment and software to reinforce the classroom teaching learning process. The Department has well established laboratories in areas such as Dynamics of Machines.

            </p>

          </div>
          <div className='col-md-4 col-sm-12'  >
            <center>  <img src={machine} alt='error13' className='img-fluid'></img></center>

          </div>
        </div>
        <div className="row mt-4">
          <div className='col-md-4 col-sm-12'  >
            <center>  <img src={garden} alt='error13' className='img-fluid'></img></center>

          </div>
          <div className='col-md-8 col-sm-12' >
            <h3 style={{ color: "rgb(44, 110, 17)" }} className="mt-2">MEDICINAL GARDEN</h3>
            <p >Medicinal garden Also known as a herb garden or a garden of simples, specialised medicinal gardens have been made at least since the Middle Ages, though plants were grown for medical purposes long before. A 'simple' is a herb used on its own in medical treatment. Many modern drugs are, of course, extracted from herbs and other plants. But modern herb gardens are used more for cooking than for medical purposes.
            </p>

          </div>
        </div>







      </div>



      <br></br>
      <br></br>
      <br></br>
      <br></br>







    </>
  )
}

export default Facillities